import React from 'react'
import Modal from "../../../components/global/Modal"

const ForceLogoutModal = ({openModal, handleLogout, handleContinue}) => {
  return (
    <Modal
        title="Inactive session"
        subtitle="Your session is about to expire due to inactivity"
        open={openModal}
        maxWidth="xs"
        closable={false}
        actionsClassName="!flex !flex-row !flex-nowrap !justify-between !gap-4"
        actions={[
          {
            onClick: () => handleLogout(),
            label: "Log Out",
            className: "!border border-blue-600 text-blue-600 bg-white hover:bg-blue-100 w-fit",
          },
          {
            onClick: () => handleContinue(),
            label: "Continue session",
            className: "bg-blue-600 text-white hover:bg-blue-700 disabled:text-white disabled:bg-blue-400  w-fit",
          },
        ]}
      >
      </Modal>
  )
}

export default ForceLogoutModal